import * as React from "react";
import Box from "@mui/material/Box";
// @ts-ignore TODO ts-ignore
import {Theme, NaviStyle} from "../styles/styles.js";
// @ts-ignore TODO ts-ignore
import {CompanyInfoCard} from "./CompanyInfoCard.js";
// @ts-ignore TODO ts-ignore
import {GoodDetailsBox} from "./GoodDetailsBox.js";
import {IconButton} from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {FC, JSX} from "react";
import {GoodDetailsCardRec} from "../Model/GoodDetailsCard.ts";

export const GoodDetailsCard: FC<GoodDetailsCardRec> = (props): JSX.Element => {

    console.log("props", props)
    return (
        <Box
            sx={{
                display: "flex",
                backgroundColor: "#F2F3F5",

                [Theme.breakpoints.down("tablet")]: {
                    flexDirection: "column",

                },
                [Theme.breakpoints.up("tablet")]: {
                    flexDirection: "row",
                    width: "94vw",
                    height: "740px",
                    p: "8px",
                },
                [Theme.breakpoints.up("laptop")]: {
                    width: "60vw",
                    height: "740px",

                },
                [Theme.breakpoints.up("desktop")]: {
                    width: "51vw",
                    maxHeight: "72vh",

                },

            }}
        >
            <Box sx={{
                display: "flex", justifyContent: "center", mb: -3,

                [Theme.breakpoints.down("tablet")]: {
                    backgroundColor: "#fff",

                },
                [Theme.breakpoints.up("tablet")]: {
                    backgroundColor: "transparent",

                },
            }}>
                <IconButton onClick={props.handleCloseGoodDetailsModal}
                            sx={{
                                color: "red",
                                alignSelf: "flex-start",
                                [Theme.breakpoints.up("laptop")]: {
                                    display: "none",

                                },
                            }}>

                    <KeyboardArrowDownIcon
                        sx={{
                            fontSize: 27,
                            //bgcolor: "#fff",
                            color: "#000",
                        }}
                    />

                </IconButton>
            </Box>
            <CompanyInfoCard goodPionts={props.goodPoints}
                             logoImg={props.logoImg}
                             companyName={props.companyName}
                             companyDescription={props.companyDescription}
                             clickButtonHandler={() => {}}
                             companyInfoOnClickButtonAction={props.companyInfoOnClickButtonAction}
            />
            <GoodDetailsBox goodImg={props.goodImg}
                            goodTitle={props.goodTitle}
                            goodDescription={props.goodDescription}
                            goodDate={props.goodDate}
            />
        </Box>

    );
};


